import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-none ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
        >
            <Icon name="filter" />
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div
            class="ns-header-controls ns-d-flex ns-flex-column ns-flex-md-row ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {/* {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )} */}
            <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100 ns-mb-4">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                    label={"Sort by"}
                /> */}
            </div>
        </div>
    )
}
